// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3RuFx","content":"styles_content__2Ml0J","checkbox":"styles_checkbox__1KvFx","checkboxLabel":"styles_checkboxLabel__aXomo"};